import EnvironmentConfiguration from "../../../constants/EnvironmentConfiguration";
import useLeadCustomerQualification from "../../../UseLeadCustomerQualification";

const ActiveComponent: React.FC = () => {
  useLeadCustomerQualification();
  return null;
};

/** A quick component wrapper to mount the legacy {@link useLeadCustomerQualification} hook. */
const AppContextUseLeadCustomerQualification: React.FC = EnvironmentConfiguration.postCustomerQualifications
  ? ActiveComponent
  : () => null;

export default AppContextUseLeadCustomerQualification;
